<template>
	<c-dialog ref="dialog" :title="title" mask-close @resolve="resolve">
		<div class="c-datetime-picker">
			<div class="flex">
				<c-gear v-for="(item, i) in gearList" :key="i" ref="gear" class="flex-grow" :list="toothData[item]" :text="unitData[item]" :style="{'flex-grow': item ? 1 : 1.4}" @change="changeHandle(item, $event)"></c-gear>
			</div>
		</div>

		<template v-if="clear" #handle>
			<div class="c-dialog-handle-item close flex-center" @click="clearHandle"><i class="c-icon-besom"></i></div>
		</template>
	</c-dialog>
</template>

<script>
	import cGear from './gear.vue'

	export default {
		name: 'cDatetimePicker',

		components: {
			cGear
		},
		
		props: {
			title: String,
			clear: {
				type: Boolean,
				default: true
			},
			value: String,
			type: {
				type: String,
				default: 'datetime'
			},
			timeAccuracy: {
				type: String,
				default: 'sec'
			},
			start: String,
			end: String,
			min: String,
			max: String,
			format: {
				type: String,
				default: 'yyyy-MM-dd hh:mm:ss'
			}
		},

		data() {
			return {
				toothData: [[], [], [], [], [], []],
				unitData: ['年', '月', '日', '时', '分', '秒']
			}
		},
		
		computed: {
			gearList() {
				let list = this.type.includes('date') ? [0, 1, 2] : [];
				if (this.type != 'date') {
					if (this.timeAccuracy == 'hour') {
						list = list.concat([3]);
					} else if (this.timeAccuracy == 'min') {
						list = list.concat([3, 4]);
					} else {
						list = list.concat([3, 4, 5]);
					}
				}
				return list;
			},

			parseRegExp() {
				let arr = [];
				if (this.type != 'time') arr.push('(\\d{4})-(\\d{1,2})-(\\d{1,2})');
				if (this.type != 'date') {
					arr.push(new Array(this.timeAccuracy == 'hour' ? 1 : this.timeAccuracy == 'min' ? 2 : 3).fill('(\\d{0,2})').join(':'));
				}
				return new RegExp(arr.join(' '));
			}
		},
		
		mounted() {
			for (let i = 1900; i <= 2100; i++) {
				this.toothData[0].push(i);
			}
			for (let i = 1; i <= 12; i++) {
				this.toothData[1].push(this.db(i));
			}
			for (let i = 0; i < 24; i++) {
				this.toothData[3].push(this.db(i));
			}
			for (let i = 0; i < 60; i++) {
				this.toothData[4].push(this.db(i));
				this.toothData[5].push(this.db(i));
			}
			this.updateDayTooth();
		},

		methods: {
			open(val) {
				this.$refs.dialog.open();
				this.$nextTick(() => {
					let data = this.parseDate(val || new Date().format('yyyy-MM-dd 00:00:00'));
					this.gearList.forEach((item, index) => {
						this.$refs.gear[index].set(this.toothData[item].findIndex(val => val == data[item] || 0));
					});	
					this.updateDayTooth();
				});
			},

			changeHandle(type, index) {
				if ([0, 1].includes(type)) {
					this.updateDayTooth();
					if (this.toothData[2].length - 1 < this.$refs.gear[2].get()) {
						this.$refs.gear[2].set(this.toothData[2].length - 1);
					}
				}
			},

			updateDayTooth() {
				let total = new Date(this.toothData[0][this.$refs.gear[0].get()], this.$refs.gear[1].get() + 1, 0).getDate();
				let list = [];
				for (let i = 1; i <= total; i++) {
					list.push(this.db(i));
				}
				this.$set(this.toothData, 2, list);
			},

			parseDate(str = '') {
				let data = str.match(this.parseRegExp);
				if (data && this.type == 'time') {
					data.splice(1, '2000', '01', '01');
				}
				return data ? (new Array(6).fill('')).map((item, index) => this.db(data[index + 1])) : null;
			},

			db(n = 0) {
				n = parseInt(n);
				return n < 10 ? '0' + n : n.toString();
			},

			clearHandle() {
				this.$emit('input', '');
				this.$refs.dialog.close();
			},

			resolve() {
				let data = this.toothData.map((item, index) => {
					index = this.gearList.findIndex(item => item == index);
					return index == -1 ? 0 : item[this.$refs.gear[index].get()];
				});
				this.$emit('input', new Date(`${data[0] || '2000'}-${data[1] || '01'}-${data[2] || '01'} ${data[3] || '00'}:${data[4] || '00'}:${data[5] || '00'}`).format(this.format));
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
